interface IConfig {
    // Geolocation
    IP_API_KEY: string;

    // Feature Flags
    ENABLE_CHECKOUT_CAPTCHA: boolean;
}

const _config: IConfig = {
    IP_API_KEY: "hLBHZmO20oHgSME",

    ENABLE_CHECKOUT_CAPTCHA: true,
};

export const config = {
    update: (newConfig: Partial<IConfig>): void => {
        Object.assign(_config, newConfig);
    },

    set: <K extends keyof IConfig>(key: K, value: IConfig[K]): void => {
        _config[key] = value;
    },

    get: <K extends keyof IConfig>(key: K): IConfig[K] => {
        if (_config[key] === null) {
            console.warn(
                `WARNING: tsi-common-react config key ${key} is not set.`,
            );
        }
        return _config[key];
    },
};
